const gotData = (state, payload) => {
  state[payload.model] = payload.data
}
const gotRawData = (state, payload) => {
  state.raw.problem1.push(payload.data.problem1)
  state.raw.problem2.push(payload.data.problem2)
  state.raw.all.push(payload.data.problem1, payload.data.problem2)  
}
export default {
  gotData,
  gotRawData
}
